import { useDispatch, useSelector } from "react-redux";
import {
  selectSelectedElement,
  selectSelectedElementType,
  updateSelectedInteraction,
} from "../../../app/slices/TrainingSlice";
import { ITransition } from "../../../models/interactions/Transition";
import { normalizeTransition } from "../../../models/interactions/TransitionDefaults";
import TransitionEditor from "../../viewport3d/TransitionEditor";
import PiPopupWindowPreview from "../components/PiPopupWindowPreview";
import PiPopupHeaderBar from "../components/PiPopupHeaderBar";
import { InteractionType } from "../../../models/interactions/Interaction";

/**
 * Editor preview for a Transition added to a take's interaction list via the
 * interaction picker. The take-level transition (take.transition field) is
 * edited by ViewportTransitionWindow instead; selecting it also resolves to
 * an element with a type, so this preview gates on the element type to avoid
 * rendering alongside that window.
 */
export default function TransitionPreview() {
  const dispatch = useDispatch();
  const selectedElement = useSelector(selectSelectedElement);
  const selectedElementType = useSelector(selectSelectedElementType);

  if (selectedElementType !== "interaction") return null;

  const transition = normalizeTransition(selectedElement as ITransition);

  return (
    <PiPopupWindowPreview
      size="large"
      header={<PiPopupHeaderBar interactionType={InteractionType.Transition} title="Transition" />}
      body={
        <div className="transitionpreview-body">
          <TransitionEditor
            transition={transition}
            onChange={(next) => dispatch(updateSelectedInteraction(next))}
          />
        </div>
      }
    />
  );
}
